import { render, staticRenderFns } from "./fail-verify.vue?vue&type=template&id=bd29182e"
import script from "./fail-verify.vue?vue&type=script&lang=js"
export * from "./fail-verify.vue?vue&type=script&lang=js"
import style0 from "./fail-verify.vue?vue&type=style&index=0&id=bd29182e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports